import React, { FC } from 'react';
import { TooltipProps } from 'recharts';

import { formatCurrency } from '@portals/utils';

import { CustomTooltip } from '../common';

export const TooltipRenderer: FC<TooltipProps<any, any>> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    return (
      <CustomTooltip
        label={label}
        items={payload.map(({ value, name }) => ({
          label: name,
          value: `${formatCurrency(value, 'USD')}`,
        }))}
      />
    );
  }

  return null;
};
